/**
 * @generated SignedSource<<f3d452b3b96db5446ce45e7db94299a1>>
 * @relayHash 6f82bc10e075c9e5112b6fd34ec255cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9d24ef38c8cbe03727b3410a36f95000071dbb165369135b8c8290458d9d4ea9

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation = {
  response: combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation$data;
  variables: combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "fields": [
              {
                "items": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "channel",
                        "value": "SLACK"
                      },
                      {
                        "kind": "Variable",
                        "name": "isEnabled",
                        "variableName": "isEnabled"
                      },
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "DAILY_DUE_DATE_NOTIFICATION"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "preferences.0"
                  }
                ],
                "kind": "ListValue",
                "name": "preferences"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "JiraUpdateGlobalPreferencesPayload",
        "kind": "LinkedField",
        "name": "updateGlobalNotificationPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9d24ef38c8cbe03727b3410a36f95000071dbb165369135b8c8290458d9d4ea9",
    "metadata": {},
    "name": "combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "bd1e431b372bf7c0fda8fafe9e62362d";

export default node;
